import { render, staticRenderFns } from "./Projets.vue?vue&type=template&id=f0bee00c&scoped=true&lang=true&"
import script from "./Projets.vue?vue&type=script&lang=js&"
export * from "./Projets.vue?vue&type=script&lang=js&"
import style0 from "./Projets.vue?vue&type=style&index=0&id=f0bee00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bee00c",
  null
  
)

export default component.exports